import {useEffect, useState} from 'react';
import routes from '../../../../../Routes/routes';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getColumns, getSections } from '../Model/Model';
import { MODELS } from '../../../../../Apis/Models';
import { TABLES } from '../../../../../Apis/Tables';
import { useDispatch, useSelector } from 'react-redux';
import {
    GetDeliveryById,
    GetEquipmentDetailsById,
} from '../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { STATUS_ICON_MODEL } from './../../RequestDocumentation/Model/Model';
import { chipStatusClassColor} from '../../../../../enums/statusColorEnum';
import {clearGetDeliveryById} from "../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentSlice";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

export const DetailsEquipmentMaterialApp = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    // Tracks which row is currently expanded
    const [expandedRowId, setExpandedRowId] = useState(null);
    const option = TABLES.EQUIPMENT_ACCESS_LOG;
    const dispatch = useDispatch();
    const moduleId = `${MODELS.EQUIPMENT_ACCESS_LOG}`;
    const equipment = useSelector((state) => state?.equipmentSlice?.equipmentDetailsById);
    const materialType = equipment?.equipmentOwner;
    const deliveryById = useSelector((state) => state?.equipmentSlice?.getDeliveryById);

    const statusId = deliveryById?.statusId;
    const statusData = statusId ? STATUS_ICON_MODEL[statusId] : null;
    const chipClass = chipStatusClassColor[statusId];
    const { id } = useParams();

    // Fetches equipment details when the component is mounted
    useEffect(() => {
        if (!id) return;
        // Request equipment details by ID
        dispatch(GetEquipmentDetailsById(id)).then(
            ({
                payload: {
                    data: { success, data },
                },
            }) => {
                if (!success) return;
                // If the equipment has an associated delivery,
                // fetch the delivery details
                if (data?.equipmentDeliveryId) {
                    dispatch(GetDeliveryById(data.equipmentDeliveryId));
                }else{
                    dispatch(clearGetDeliveryById());
                }
            },
        );
    }, []);

    // Navigates back to the list page
    const goBack = () => {
        navigate(routes.equipmentAndMaterial.list);
    };
    // Handles expansion of a detail row
    const handleRowExpand = (row) => {
        if (row?.id !== expandedRowId) {
            setExpandedRowId(row?.id);
        }
    };

    // Table column configuration
    const columns = getColumns({
        t,
        id,
        moduleId,
        option,
        statusId,
        statusData,
        chipClass,
        dispatch
    });
    // Section configuration for the detail view
    const sections = getSections( materialType );

    return {
        goBack,
        handleRowExpand,
        columns,
        sections,
        t,
        materialType
    };
};
export default DetailsEquipmentMaterialApp;
